// --------------------------------------------------------------
// Created On: 2021-10-01
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import validateNickname from "../../../../../utilities/validateNickname";
import styles from "./AssociatedAssetItem.module.scss";

// A single associated asset in the asset group modal.
export default function AssociatedAssetItem(props: Props): Component {
  return (
    <Fragment>
      <div data-test="assetgroup-associated-asset-item" className={`${styles.body} px-4 py-2`}>
        {props.name} {validateNickname(props.nickname, props.name) ? `(${props.nickname})` : ""}
      </div>
    </Fragment>
  );
}

interface Props {
  assetId: number;
  name: string;
  nickname?: string;
  productType?: string;
  productModel?: string;
  productManufacturer?: string;
}
